import { createRouter, createWebHashHistory } from 'vue-router'
import Layout from '@/layout/index.vue'

const router = createRouter({
  history: createWebHashHistory(),
  routes: [
    {
      path: '/',
      name: 'home',
      component: Layout,
      redirect(to) {
        if (to.path === '/') return '/home'

        return to.fullPath
      },
      children: [
        {
          path: 'home',
          name: 'HOME',
          component: () => import('@/views/Home/index.vue'),
        },
        {
          path: 'search',
          name: 'Search',
          component: () => import('@/views/search/index.vue'),
        },
        {
          path: 'bookDetail',
          name: 'BookDetail',
          component: () => import('@/views/bookDetail/index.vue'),
        },
        {
          path: 'user',
          name: 'User',
          component: () => import('@/views/user/index.vue'),
        },
        {
          path: 'learningProgress',
          name: 'learningProgress',
          component: () => import('@/views/learningProgress/index.vue'),
        },
      ],
    },
    {
      path: '/reader',
      name: 'Reader',
      component: () => import('@/views/reader/index.vue'),
      meta: {
        isWhiteList: true,
      },
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/login/index.vue'),
      meta: {
        isWhiteList: true,
      },
    },
    {
      path: '/learnMall/:ltiContextId',
      name: 'learnMallRedirect',
      component: () => import('@/views/learnMall/learnMallRedirect.vue'),
      meta: {
        isWhiteList: true,
      },
    },
    {
      path: '/ssoLogin/:oauth2ContextId',
      name: 'ssoLogin',
      component: () => import('@/views/login/SSORedirect.vue'),
      meta: {
        isWhiteList: true,
      },
    },
    {
      path: '/learnMall/bookSelect',
      name: 'learnMallBookSelect',
      component: () => import('@/views/learnMall/LearnMallSearch.vue'),
      meta: {
        isWhiteList: true,
      },
    },
    {
      path: '/learnMall/bookDetail',
      name: 'learnMallBookDetail',
      component: () => import('@/views/bookDetail/learnMallDetail.vue'),
      meta: {
        isWhiteList: true,
      },
    },
    {
      path: '/learnMall/progress',
      name: 'learnMallBookProgress',
      component: () => import('@/views/learningProgress/index.vue'),
      meta: {
        isWhiteList: true,
      },
    },
    {
      path: '/error404',
      name: 'error404',
      component: () => import('@/views/error/404.vue'),
      meta: {
        isWhiteList: true,
      },
    },
    {
      path: '/register',
      name: 'register',
      component: () => import('@/views/register/index.vue'),
      meta: {
        isWhiteList: true,
      },
    },
    {
      path: '/forgotPwd',
      name: 'forgotPwd',
      component: () => import('@/views/resetPassword/index.vue'),
      meta: {
        isWhiteList: true,
      },
    },
    {
      path: '/resetPwd',
      name: 'resetPwd',
      component: () => import('@/views/resetPassword/reset.vue'),
      meta: {
        isWhiteList: true,
      },
    },
    {
      path: '/:pathMatch(.*)',
      redirect: '/error404',
      meta: {
        isWhiteList: true,
      },
    },
  ],
})

export default router
